import React, { useState } from "react";
import PartstechQuoteOrder from "../child_components/PartstechQuoteOrder";
import { toast } from "react-toastify";
import Loader from "../reusable_components/Loader.jsx";
import { placeOrder } from "../api/partstechApi";

const PartstechQuoteDetails = ({ data, setReloadTable, setIsModalOpen }) => {
  const [loader, setLoader] = useState(false);
  const { orders: orderData, id: orderId, isOrderPlaced, orderType } = data;

  if (!data) {
    return <p className='text-gray-500 text-center mt-4'>No data available</p>;
  }

  const orderParts = async (orders) => {
    try {
      setLoader(true);
      const result = await placeOrder(orders, orderId, orderType);

      if (result.status === 200) {
        toast.success("Order placed successfully", { autoClose: 3000 });
        setReloadTable((prev) => !prev);
        setIsModalOpen(false);
      } else {
        toast.error("Couldn't place order", { autoClose: 3000 });
      }
    } catch (err) {
      toast.error("Failed to place order", { autoClose: 3000 });
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className='p-4'>
      <div className='max-h-[400px] overflow-y-scroll space-y-4'>
        {isOrderPlaced === false && (
          <button
            className='ml-2 flex items-center gap-2 px-3 py-1 text-sm rounded-md bg-blue-500 text-white hover:scale-105 transform transition-all duration-200'
            onClick={() => orderParts(orderData.orders)}
            disabled={loader}
          >
            Order Parts
            {loader && <Loader />}
          </button>
        )}
        {orderData.orders.map((order, index) => {
          return (
            <PartstechQuoteOrder
              key={`order-${index}`}
              orderData={order}
              index={index}
              isOrderPlaced={isOrderPlaced}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PartstechQuoteDetails;
